export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  function modifyTitle(data) {
    const { Title: text } = data.items[0];
    const h2 = `<h2 class="card-widget-title" aria-label="${text}">${text}</h2>`;
    $widgetHTML.find('span.card-widget-title').replaceWith(h2);
  }

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: true,
      // text: 'EXPLORE THE MAP',
    },
    cardWidgetLoaded: function (data, _owl, hasData) {
      const { DetailLinkText: secondButton } = data.items[0];
      const button = $widgetHTML.find('a');
      if (hasData) {
        modifyTitle(data);
        button.each((x, item) => {
          if ($(item).hasClass('buyNowButton')) {
            $(item).text(secondButton);
            $(item).attr('aria-label', secondButton);
            $(item).attr('target', '_blank');
          }
          $(item).addClass('button');
        });
      } else {
        $widgetHTML.remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'LEARN MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}
